export default {
  version: process.env.REACT_APP_VERSION,
  api: {
    baseUrl: process.env.REACT_APP_BASE_URL,
    fileUrl: process.env.REACT_APP_FILE_URL,
  },
};
